var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TextField',{attrs:{"disabled":true,"readonly":true,"clearable":false,"value":_vm.prefix,"type":_vm.type,"label":_vm.label,"placeholder":_vm.placeholder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }